import type { ReactElement } from 'react';
import { Link } from 'react-router';

import { RESTORE_SCROLL_STATE } from './scroll-policy';

import type { BackTarget } from '@/lib/back-nav';

/** Enlace "volver" del encabezado de una pantalla de detalle (ver `lib/back-nav`). Pide
 *  al ScrollManager recuperar la posición en que se dejó el origen (QA F1 UX-03). */
export function BackLink({ target }: { target: BackTarget }): ReactElement {
  const state =
    target.scrollKey === undefined
      ? target.state
      : { ...target.state, [RESTORE_SCROLL_STATE]: target.scrollKey };
  return (
    <Link to={target.to} state={state} className="back">
      ← {target.label}
    </Link>
  );
}
